export const ruleTypes = ['MODPLAN', 'GENERIC', 'FARKEN-ERROR'];
export const matcherTypes = [
    'primitive',
    'pattern',
    'isNull',
    'isUndefined',
    'isTruthy',
    'isFalsy',
    'isEmpty',
];
//# sourceMappingURL=types.js.map